var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import useMediaQuery from "@mui/material/useMediaQuery";
import { CloseWithoutBorder } from "../../../../../assets/images";
import { DynamicFormBuilderContainer } from "../../../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.container";
import { FormItemTypes } from "../../../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.entity";
import { SinglePopupRemarksCreate, SinglePopupRemarksUpdate } from "../../../services/apiCalls";
import { getLocalStorageItem } from "../../../../../utils/storageHelper";
import { showSurface } from "../../../../../redux/awaitedSurfacesSlice";
import { InfoIcon } from "../../../../../assets/customIcons";
import ConfirmationPopUp from "../../../../fieldFailureReports/components/confirmationPopUp";
import { useAppDispatch } from "../../../../../store/hooks";
export var ASMRemarks = function (_ref) {
    var _getLocalStorageItem, _PersonData$data;
    var row = _ref.row, onClose = _ref.onClose;
    var IS_MOBILE = useMediaQuery(function (theme) { return theme.breakpoints.down("sm"); });
    var IS_DESKTOP = useMediaQuery(function (theme) { return theme.breakpoints.up("sm"); });
    console.log("rowwww from ASM remarks", row);
    var Data = (_getLocalStorageItem = getLocalStorageItem("CHANNEL_LIST")) === null || _getLocalStorageItem === void 0 || (_getLocalStorageItem = _getLocalStorageItem[0]) === null || _getLocalStorageItem === void 0 || (_getLocalStorageItem = _getLocalStorageItem.BranchDetails[0]) === null || _getLocalStorageItem === void 0 ? void 0 : _getLocalStorageItem.OrganizationId;
    var organizationId = Data;
    var PersonData = getLocalStorageItem("USER_PROFILE_DATA");
    var BranchData = getLocalStorageItem("SELECTED_BRANCH");
    var branchId = BranchData === null || BranchData === void 0 ? void 0 : BranchData.OrganizationId;
    var PersonId = PersonData === null || PersonData === void 0 || (_PersonData$data = PersonData.data) === null || _PersonData$data === void 0 ? void 0 : _PersonData$data.IdentityId;
    var paramsData;
    var dispatch = useAppDispatch();
    var APIDATA;
    if ((row === null || row === void 0 ? void 0 : row.ActionTaken) === "Accept") {
        APIDATA = SinglePopupRemarksCreate;
        paramsData = {
            "OrganizationId": organizationId,
            "BranchId": branchId,
            "FieldFailureReports": [{
                    "FieldFailureReportId": row === null || row === void 0 ? void 0 : row.id,
                    "IsParent": "1",
                    "Remark": row === null || row === void 0 ? void 0 : row.Remarks,
                    "UserId": PersonId
                }]
        };
    }
    else if ((row === null || row === void 0 ? void 0 : row.ActionTaken) === "ResendToDealer") {
        APIDATA = SinglePopupRemarksUpdate;
        paramsData = {
            "StatusKey": "ResentByASM",
            "UserId": PersonId,
            "BranchId": branchId,
            "OrganizationId": organizationId,
            "FFRList": [{
                    "FieldFailureReportId": row === null || row === void 0 ? void 0 : row.id,
                    "Remark": row === null || row === void 0 ? void 0 : row.Remarks
                }]
        };
    }
    else if ((row === null || row === void 0 ? void 0 : row.ActionTaken) === "CloseToFFR") {
        paramsData = {
            "StatusKey": "ClosedByASM",
            "UserId": PersonId,
            "BranchId": branchId,
            "OrganizationId": organizationId,
            "FFRList": [{
                    "FieldFailureReportId": row === null || row === void 0 ? void 0 : row.id,
                    "Remark": row === null || row === void 0 ? void 0 : row.Remarks
                }]
        };
        APIDATA = SinglePopupRemarksUpdate;
    }
    var formData = [{
            type: FormItemTypes.ContainerItem,
            name: '',
            columnSize: 12,
            elements: [{
                    type: FormItemTypes.CardComponent,
                    label: '',
                    name: '',
                    columnSize: 12,
                    sx: {
                        border: "none"
                    },
                    elements: [{
                            type: FormItemTypes.Typography,
                            name: "",
                            columnSize: 10,
                            fontSize: "large ",
                            fontWeight: "strong",
                            children: "Select the FFR to take action"
                        }, {
                            type: FormItemTypes.IconButton,
                            label: '',
                            name: '',
                            value: null,
                            columnSize: 2,
                            children: /*#__PURE__*/ React.createElement("img", {
                                src: CloseWithoutBorder
                            }),
                            onClick: function () {
                                onClose();
                            }
                        }, {
                            type: FormItemTypes.TextInput,
                            name: 'Remarks',
                            label: 'ASM remarks',
                            multiline: true,
                            columnSize: 12,
                            minRows: IS_DESKTOP ? 6 : 3,
                            placeholder: 'Enter a description....',
                            //  sx: { padding: '10px 0px' },
                            setFieldProps: function (formValues, value) {
                                return {
                                    type: this.type,
                                    label: "ASM remarks",
                                    inputProps: {
                                        maxLength: 500
                                    }
                                };
                            }
                        }]
                }]
        }, {
            type: FormItemTypes.ContainerItem,
            name: "",
            display: "flex",
            columnSize: 12,
            justifyContent: IS_DESKTOP ? "flex-end" : "none",
            elements: [{
                    type: FormItemTypes.Button,
                    name: "",
                    sx: {
                        width: IS_DESKTOP ? "77px" : "342px",
                        marginLeft: "12px"
                    },
                    children: "Cancel",
                    variant: "outlined",
                    onClick: function () {
                        onClose();
                    }
                }, {
                    type: FormItemTypes.Button,
                    name: "",
                    sx: {
                        width: IS_DESKTOP ? "77px" : "342px",
                        marginLeft: "12px"
                    },
                    children: "Save",
                    variant: "contained",
                    onClick: function () {
                        return __awaiter(this, void 0, void 0, function () {
                            var result;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, dispatch(showSurface({
                                            type: 'Dialog',
                                            Component: ConfirmationPopUp,
                                            containerProps: {
                                                fullWidth: true,
                                                PaperProps: {
                                                    sx: {
                                                        borderRadius: '12px',
                                                        width: {
                                                            sm: '350px',
                                                            md: '450px',
                                                            lg: '450px'
                                                        }
                                                    }
                                                }
                                            },
                                            //Passing dynamic props
                                            componentProps: {
                                                unsavedChangesMessage: 'Are sure you want to submit?',
                                                changesLostMessage: 'Actions taken cannot be undone.',
                                                confirmButtonLabel: 'Submit',
                                                discardButtonLabel: 'Cancel',
                                                icon: /*#__PURE__*/ React.createElement(InfoIcon, null),
                                                bgColor: 'warning.100',
                                                hoverbgColor: 'warning.100'
                                                // onClose: (isConfirmed: boolean) => {
                                                //   console.log(isConfirmed ? 'Confirmed' : 'Canceled');
                                                // },
                                            }
                                        }))];
                                    case 1:
                                        result = _a.sent();
                                        if (result.payload) {
                                            return [2 /*return*/, 'submit'];
                                        }
                                        return [2 /*return*/];
                                }
                            });
                        });
                    }
                }]
        }];
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(DynamicFormBuilderContainer, {
        formData: formData,
        mode: "edit",
        updateFormAPI: APIDATA,
        updateRequest: paramsData,
        gridProps: {
            spacing: 0
        }
    }));
};
